import { useEffect, useState } from 'react'

export const useGetProductionEnvironment = (): boolean => {
  const [isProductionEnvironment, setIsProductionEnvironment] = useState(false)
  useEffect(() => {
    setIsProductionEnvironment(window.location.href.indexOf('https://vision.truepill.com/') === 0)
  }, [])
  return isProductionEnvironment
}
